export default "__VITE_ASSET__Cr1yB$9k__"